(function () {
  var FREE_SHIPPING_THRESHOLD_CENTS = 7500;

  function parsePriceCents(text) {
    var match = text && text.match(/[\d,]+\.\d{2}/);
    if (!match) return null;
    return Math.round(parseFloat(match[0].replace(/,/g, '')) * 100);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function isSubscriptionSelected(root) {
    return !!root.querySelector('[data-radio-type="selling_plan"]:checked');
  }

  function updateContainer(container) {
    var priceSource = document.getElementById(container.dataset.priceSource);
    if (!priceSource) return;

    var oneTimeCents = parsePriceCents(priceSource.textContent);
    if (oneTimeCents === null) return;

    var discount = parseFloat(container.dataset.discount || '1');
    var subscriptionCents = Math.round(oneTimeCents * discount);

    var selectedCents = isSubscriptionSelected(document) ? subscriptionCents : oneTimeCents;
    var remaining = FREE_SHIPPING_THRESHOLD_CENTS - selectedCents;

    var textEl = container.querySelector('[data-shipping-progress-text]') || container;
    if (remaining <= 0) {
      textEl.textContent = 'Qualifies for free U.S. shipping.';
    } else {
      textEl.textContent = "You're " + formatMoney(remaining) + ' away from free U.S. shipping.';
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-shipping-progress]').forEach(updateContainer);
  }

  function init() {
    updateAll();

    document.addEventListener('change', function (event) {
      if (event.target && event.target.hasAttribute('data-radio-type')) {
        updateAll();
      }
    });

    document.querySelectorAll('[data-shipping-progress]').forEach(function (container) {
      var priceSource = document.getElementById(container.dataset.priceSource);
      if (!priceSource) return;
      var observer = new MutationObserver(function () {
        updateContainer(container);
      });
      observer.observe(priceSource, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
